import qs from "qs";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import * as Const from "../../pages/amex/constants/TransactionConstants";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import dayjs from "dayjs";

export const useAmexTransactionsRepository = () => {
    const { GET, POST} = useApi();

    const PATH = "/finance/amexsof/transactions";

    const DATE_FIELDS = [
        Const.ID_FILTER_EXPIRATION_DATE_FROM,
        Const.ID_FILTER_EXPIRATION_DATE_TO
    ];
    const OTHER_FIELDS = [
        Const.ID_FILTER_TYPE,
        Const.ID_FILTER_STATUS,
        Const.ID_FILTER_NETWORK_CODE
    ];

    async function getTransactions(offset: number, limit: number, sort: string | null, order: string | null, reportId: string | undefined, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let type = getFilterValue(Const.ID_FILTER_TYPE, filterDefs);
        let statuses = getFilterValue(Const.ID_FILTER_STATUS, filterDefs);
        let networkCode = getFilterValue(Const.ID_FILTER_NETWORK_CODE, filterDefs);
        let expirationDateFrom: Date = getFilterValue(Const.ID_FILTER_EXPIRATION_DATE_FROM, filterDefs);
        let expirationDateTo: Date = getFilterValue(Const.ID_FILTER_EXPIRATION_DATE_TO, filterDefs);

        let params = {
            reportId: reportId,
            offset: offset,
            limit: limit,
            sortBy: sort,
            order: order,
            type: type,
            networkCode: networkCode,
            status: statuses,
            expirationDateFrom: expirationDateFrom ? dayjs(expirationDateFrom).toISOString() : null,
            expirationDateTo: expirationDateTo ? dayjs(expirationDateTo).toISOString() : null,
        }

        let response = await GET(`${PATH}`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic);
        })
    }

    function transactionSummary(
        id: string | undefined,
        filterDefs: FilterDef[] = []
    ): Promise<HTTPGenericResponse> {
        let params: any = {};

        DATE_FIELDS.forEach((p) => {
            let date: Date = getFilterValue(p, filterDefs);
            params[p] = date ? dayjs(date).toISOString() : null;
        });
        OTHER_FIELDS.forEach((p) => {
            params[p] = getFilterValue(p, filterDefs);

        });
        if (id) params["reportId"] = id;
        return GET(`${PATH}/all-status-summary`, {
            params: params,
            paramsSerializer: (params) =>
                qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
        });
    }


    return { getTransactions, transactionSummary };
}